import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

// Button that stays visible but disabled (with reason tooltip) when the role lacks the permission.
export function Can({ perm, children, ...props }) {
  const { can, reason } = useAuth();
  const allowed = can(perm);
  if (allowed) return <Button {...props}>{children}</Button>;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span tabIndex={0} className="inline-flex" aria-label={reason(perm)}>
          <Button {...props} disabled aria-disabled="true" className={`${props.className || ""} pointer-events-none`}>{children}</Button>
        </span>
      </TooltipTrigger>
      <TooltipContent side="bottom">{reason(perm)}</TooltipContent>
    </Tooltip>
  );
}
